
export default {
  name: 'FooterComponent',
}
